var ODD_FRACTIONAL_PART = 2;
var normalizeNumberOutput = function (value, accuracy) {
    if (accuracy === void 0) { accuracy = 0; }
    return parseFloat(String(value)).toFixed(accuracy);
};
var normalizeOddOutput = function (value) {
    return normalizeNumberOutput(value, ODD_FRACTIONAL_PART);
};
export { normalizeNumberOutput, normalizeOddOutput };
